<div mat-dialog-header>
  @if (data.audit) {
    <h1>{{ categories[data.gridType] }} Audit History Download</h1>
    <div class="limit-notification">
      {{ data.selectedRecords.length || data.rows }} Records Selected (Limit
      1,000)
    </div>
    @if (
      data.selectedRecords.length > 1000 ||
      (data.selectedRecords.length === 0 && data.rows > 1000)
    ) {
      <div class="limit-warning">
        Maximum selected records exceeded. Please select fewer records to
        proceed.
      </div>
    }
  } @else {
    <h1>{{ categories[data.gridType] }} Monitor Download</h1>
    <div class="limit-notification"> Limit 100,000 records </div>
  }
</div>
<div mat-dialog-content class="dialog-container">
  @if (!downloadRequested) {
    <mat-form-field>
      <mat-label>File Name</mat-label>
      <input
        matInput
        type="text"
        appSpecialIsAlphaNumeric
        [placeholder]="'File Name'"
        [(ngModel)]="fileName"
      />
    </mat-form-field>
  } @else {
    <div> Your report has been requested. </div>
    <div> When it is finished generating you can view it </div>
    <div> at the downloaded reports page. </div>
  }
</div>
<div mat-dialog-actions class="row buttons">
  <button
    type="button"
    mat-button
    color="warn"
    (click)="dialogRef.close('Cancel')"
  >
    Cancel
  </button>
  @if (!downloadRequested) {
    <button
      type="button"
      mat-raised-button
      color="primary"
      [disabled]="
        !fileName ||
        (data.audit && data.selectedRecords.length > 1000) ||
        (data.audit && data.selectedRecords.length === 0 && data.rows > 1000)
      "
      (click)="downloadGridReport()"
    >
      <mat-icon>insert_drive_file</mat-icon>Generate Report
    </button>
  } @else {
    <button
      type="button"
      mat-raised-button
      color="primary"
      (click)="dialogRef.close('Confirm')"
    >
      Confirm
    </button>
  }
</div>
